import { Route, Routes } from "react-router-dom";
import "./App.css";
import NavigationBar from "./shared/components/NavigationBar";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import styled from "styled-components";
import {
  DropdownContentContainer,
  HorizontalCard,
  ToastProvider,
  ToastTextContainer,
} from "@laerdal/life-react-components";
import { progressPlayerModeActiveState } from "./shared/helpers/StateManager";
import UseScreenOrientation from "./shared/helpers/UseScreenOrientation";
import { useCallback } from "react";
import RotateDeviceIcon from "./resources/images/rotate-device-icon.svg";
import React from "react";

const CustomizedContainer = styled.div`
  ${DropdownContentContainer} {
    min-width: 230px;
  }
  ${ToastTextContainer} {
    width: 528px;
  }
`;

function App() {
  // Global state managers
  const [isPlayerInProgress] = progressPlayerModeActiveState();

  // Others
  const screenOrientation = UseScreenOrientation();

  // Functions
  const IsOrientationLandscape = useCallback(() => {
    return (
      screenOrientation === "landscape-primary" ||
      screenOrientation === "landscape-secondary"
    );
  }, [screenOrientation]);

  return (
    <>
      <CustomizedContainer>
        <ToastProvider>
          {isPlayerInProgress && (
            <div className="visualization-player-overlay"></div>
          )}
          {IsOrientationLandscape() && (
            <div className="main">
              <NavigationBar />
              <div style={{ display: "flex", flex: "1" }}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </div>
            </div>
          )}
          {!IsOrientationLandscape() && (
            <>
              <div className="rotate-card-overlay"></div>
              <div className="rotate-card-container">
                <HorizontalCard
                  title={"Vennligst snu nettbrettet ditt"}
                  description={
                    "Dette innholdet er optimalisert for landskapsmodus"
                  }
                  icon={React.createElement(
                    "img",
                    { src: RotateDeviceIcon, height: "48px", width: "48px" },
                    null
                  )}
                />
              </div>
            </>
          )}
        </ToastProvider>
      </CustomizedContainer>
    </>
  );
}

export default App;
